module.exports = __webpack_public_path__ + "img/icon-node-close.f6d77576.svg";